import * as React from "react"
import classNames from "classnames"
import styled from "styled-components"
import { navigate } from "gatsby"
import {
  IconSearch,
  IconCross,
  Variables
} from "@life-without-barriers/react-components"
import { sendEvent } from "@life-without-barriers/utilities"
import { Location } from "@life-without-barriers/gatsby-common"

import { toSearchQuery } from "../../lib/searchHelpers"

import SearchBoxMobile from "./SearchBoxMobile"
/**
 * MobileSearchField
 * This is a specific search field rendered for mobile.
 * It includes state for toggling the visibility of the field.
 */

const { greyDark } = Variables

const onSearch = (queryValue: string) => {
  sendEvent("Home page", "Click", "Search button")
  void navigate(
    `/foster-care/support/carer-guide/search/?${toSearchQuery(queryValue)}`
  )
}

export default class MobileSearchField extends React.Component<Props, State> {
  private searchInput: HTMLElement | undefined

  constructor(props: Props) {
    super(props)
    this.state = {
      showMobileSearchField: false
    }
  }

  /**
   * Revert state on screen resize
   * This is mainly for desktop (we dont want multiple search fields when resizing)
   * Only update state on change of width - otherwise Android will open then automatically
   * close this search field.
   */
  public componentDidMount() {
    const initialViewPortWidth = window.innerWidth

    window.addEventListener("resize", () => {
      if (initialViewPortWidth !== window.innerWidth) {
        if (this.state.showMobileSearchField) {
          this.setState({
            showMobileSearchField: false
          })
        }
      }
    })
  }

  /**
   * Apply focus to mobile search input
   */
  public componentDidUpdate() {
    if (this.searchInput) {
      this.searchInput.focus()
    }
  }

  public render() {
    const searchBoxClasses = classNames({
      "ph2 ph3-ns db bg-white z-2 h-100 w-100 relative o-0": true,
      active: this.state.showMobileSearchField
    })

    const searchIconClasses = classNames({
      "pa3 absolute right-0 right-1-ns z-5": true,
      dn: this.state.showMobileSearchField
    })

    return (
      <div className="absolute absolute--fill">
        <StyledToggleMobileSearchIcon
          className={searchIconClasses}
          onClick={() =>
            this.setState({
              showMobileSearchField: true
            })
          }
        >
          <IconSearch
            className="db t-mobile-search-icon-open"
            height="16"
            width="16"
            color={greyDark}
          />
        </StyledToggleMobileSearchIcon>

        <FieldContainer className={searchBoxClasses}>
          <StyledToggleMobileSearchIcon
            className="absolute right-1 right-2-ns z-1"
            onClick={() =>
              this.setState({
                showMobileSearchField: false
              })
            }
          >
            <IconCross className="db" height="16" width="16" color={greyDark} />
          </StyledToggleMobileSearchIcon>
          <SearchBoxMobile
            onSearch={onSearch}
            fetchChildRef={(input: unknown) =>
              (this.searchInput = input as HTMLElement)
            }
            hideButton={false}
          />
        </FieldContainer>
      </div>
    )
  }
}

interface Props {
  location: Location
}

interface State {
  showMobileSearchField: boolean
}

const StyledToggleMobileSearchIcon = styled.span`
  top: 50%;
  transform: translateY(-50%);
`

const FieldContainer = styled.div`
  transition: opacity 0.1s ease-in-out;
  &.active {
    opacity: 1;
  }
`
